export default __webpack_public_path__ + "static/media/maintenanceBackground@2x.fff26a42.png";